export const GET_COURSES = "users/GET_COURSES";
export const GET_STUDENTS = "users/GET_STUDENTS";
export const GET_COURSES_STUDENTS = "users/GET_COURSES_STUDENTS";
export const GET_SCHOOL_LIST = "assessments/GET_SCHOOL_LIST";
export const ADD_GROUP = "assessments/ADD_GROUP";
export const JOIN_GROUP = "assessments/JOIN_GROUP";
export const REMOVE_GROUP = "assessments/REMOVE_GROUP";
export const ADD_STUDENT = "assessments/ADD_STUDENT";
export const EDIT_STUDENT = "assessments/EDIT_STUDENT";
